import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "justify-content-end d-flex mt-2 flex-wrap gap-2"
}
const _hoisted_2 = { class: "table table-striped border-light" }
const _hoisted_3 = { colspan: "2" }
const _hoisted_4 = { class: "mb-0 text-center text-capitalize-first" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-capitalize-first" }
const _hoisted_12 = { class: "text-capitalize-first" }
const _hoisted_13 = { class: "text-capitalize-first" }
const _hoisted_14 = { class: "text-capitalize-first" }
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 0,
  class: "me-2"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "text-capitalize-first" }
const _hoisted_19 = { class: "text-primary" }
const _hoisted_20 = { class: "text-capitalize-first" }
const _hoisted_21 = { class: "text-capitalize-first" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 2,
  class: "ms-1"
}
const _hoisted_24 = {
  key: 3,
  class: "ms-1 small text-secondary"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "text-capitalize-first" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 2,
  class: "ms-1"
}
const _hoisted_29 = {
  key: 3,
  class: "ms-1 small text-secondary"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { class: "text-capitalize-first" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 3 }
const _hoisted_35 = { class: "text-capitalize-first" }
const _hoisted_36 = { class: "text-success" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "text-capitalize-first" }
const _hoisted_39 = { style: {"word-break":"break-all","max-width":"300px"} }
const _hoisted_40 = { class: "text-capitalize-first" }
const _hoisted_41 = { class: "d-flex flex-row align-items-start gap-2" }
const _hoisted_42 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_43 = { class: "" }
const _hoisted_44 = {
  key: 1,
  class: "text-secondary"
}
const _hoisted_45 = ["href"]
const _hoisted_46 = ["href"]
const _hoisted_47 = ["href"]
const _hoisted_48 = ["href"]
const _hoisted_49 = ["href"]
const _hoisted_50 = { key: 5 }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "text-secondary text-capitalize-first me-2" }
const _hoisted_53 = {
  key: 1,
  class: "text-secondary"
}
const _hoisted_54 = {
  key: 2,
  class: "text-secondary"
}
const _hoisted_55 = { key: 4 }
const _hoisted_56 = { class: "text-capitalize-first" }
const _hoisted_57 = { key: 5 }
const _hoisted_58 = { class: "text-capitalize-first" }
const _hoisted_59 = {
  key: 4,
  class: "overflow-auto"
}
const _hoisted_60 = { class: "table table-striped border-light" }
const _hoisted_61 = {
  colspan: "5",
  class: "text-center"
}
const _hoisted_62 = { class: "mb-0 text-center text-capitalize-first" }
const _hoisted_63 = { class: "text-capitalize" }
const _hoisted_64 = { class: "text-capitalize" }
const _hoisted_65 = {
  key: 0,
  class: "text-capitalize"
}
const _hoisted_66 = {
  class: "text-capitalize",
  colspan: "2"
}
const _hoisted_67 = { class: "text-nowrap" }
const _hoisted_68 = { class: "d-flex flex-column" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = ["href"]
const _hoisted_72 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_73 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_74 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_75 = { class: "text-lowercase" }
const _hoisted_76 = {
  key: 4,
  class: "text-lowercase text-danger"
}
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = {
  key: 1,
  class: ""
}
const _hoisted_80 = {
  key: 0,
  class: "text-capitalize-first d-inline-block"
}
const _hoisted_81 = { key: 1 }
const _hoisted_82 = { key: 2 }
const _hoisted_83 = { class: "d-flex flex-column" }
const _hoisted_84 = { key: 3 }
const _hoisted_85 = { class: "d-flex flex-column" }
const _hoisted_86 = { class: "d-flex flex-column gap-2" }
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_89 = { class: "col-sm-8" }
const _hoisted_90 = { class: "row" }
const _hoisted_91 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_92 = { class: "col-sm-8" }
const _hoisted_93 = { class: "row" }
const _hoisted_94 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_95 = { class: "col-sm-8" }
const _hoisted_96 = { class: "row" }
const _hoisted_97 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_98 = { class: "col-sm-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!
  const _component_ManualSbpQrLinkEditor = _resolveComponent("ManualSbpQrLinkEditor")!
  const _component_MatchingPayInDealsDetailsTable = _resolveComponent("MatchingPayInDealsDetailsTable")!
  const _component_TransferTransactionDetailsTable = _resolveComponent("TransferTransactionDetailsTable")!
  const _component_ExternalNSPKTransactionDetailsTable = _resolveComponent("ExternalNSPKTransactionDetailsTable")!
  const _component_ReceiptCheckStatus = _resolveComponent("ReceiptCheckStatus")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_InvoiceRequestsTimelineModal = _resolveComponent("InvoiceRequestsTimelineModal")!
  const _component_WebhookHistoryModal = _resolveComponent("WebhookHistoryModal")!
  const _component_MerchantRequestLogModal = _resolveComponent("MerchantRequestLogModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.deal && _ctx.showDealActionsRow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.hasRole([_ctx.UserRole.ADMIN]))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showRequestLog && _ctx.showRequestLog(...args))),
                  class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                }, _toDisplayString(_ctx.helper.trans('labels.show_request_log')), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showWebhooksHistory && _ctx.showWebhooksHistory(...args))),
                  class: "btn btn-outline-secondary btn-sm text-capitalize-firs ms-1"
                }, _toDisplayString(_ctx.helper.trans('labels.show_webhooks_history')), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showRequestsTimeline(_ctx.deal.id))),
                  class: "btn btn-outline-secondary btn-sm text-capitalize-first ms-1"
                }, _toDisplayString(_ctx.helper.trans('labels.show_requests_timeline')), 1),
                (_ctx.canResendWebhook)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-sm btn-outline-secondary text-capitalize-first ms-1",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.sendCallback(_ctx.deal.id)), ["prevent"]))
                    }, _toDisplayString(_ctx.helper.trans('labels.send_webhook')), 1))
                  : _createCommentVNode("", true)
              ], 64))
            : (_ctx.canOperatorResendWebhook)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-sm btn-outline-secondary text-capitalize-first",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.sendCallback(_ctx.deal.id)), ["prevent"]))
                }, _toDisplayString(_ctx.helper.trans('labels.send_webhook')), 1))
              : _createCommentVNode("", true),
          (_ctx.deal.paymentOption === _ctx.PaymentOption.MANUAL_ECOM)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showClientCard && _ctx.showClientCard(...args))),
                class: "btn btn-outline-primary btn-sm text-capitalize-first"
              }, _toDisplayString(_ctx.helper.trans('labels.show_client_card')), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_3, [
            _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.trade_deal')), 1)
          ])
        ])
      ]),
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
          (_ctx.isProvider)
            ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.deal.id) + " ", 1),
                _createVNode(_component_copy_button, {
                  value: _ctx.deal?.id
                }, null, 8, ["value"]),
                (_ctx.deal?.aggregatorExternalId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("small", _hoisted_8, [
                        _createTextVNode(_toDisplayString(_ctx.deal.aggregatorExternalId) + " ", 1),
                        _createVNode(_component_copy_button, {
                          value: _ctx.deal.aggregatorExternalId
                        }, null, 8, ["value"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("td", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.deal.publicId) + " ", 1),
                _createVNode(_component_copy_button, {
                  value: _ctx.deal?.publicId
                }, null, 8, ["value"])
              ]))
        ]),
        (_ctx.deal.transactionId)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.helper.trans('labels.transaction')), 1),
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(_ctx.deal.transactionId) + " ", 1),
                _createVNode(_component_copy_button, {
                  value: _ctx.deal.transactionId
                }, null, 8, ["value"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.type')), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`direction.${_ctx.deal.type}`)), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.helper.trans('labels.date')), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(_ctx.deal.createdAt)), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
          _createElementVNode("td", null, [
            _createTextVNode(_toDisplayString(_ctx.helper.trans(`deal_status.${_ctx.deal.status}`)) + " ", 1),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deal.attachments, (attachment) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: attachment.id
                }, [
                  _createElementVNode("a", {
                    href: `${_ctx.api.baseUrl()}/attachments/${attachment.file}`,
                    target: "_blank",
                    type: "button",
                    class: "me-2 text-warning"
                  }, _cache[11] || (_cache[11] = [
                    _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)
                  ]), 8, _hoisted_15),
                  (_ctx.chequeCheckerEnabled && _ctx.receiptVerdict(_ctx.deal, attachment.id))
                    ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(_ctx.receiptVerdict(_ctx.deal, attachment.id)), 1))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ]),
        (_ctx.deal.disputeResult)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
              _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.helper.trans('labels.dispute_result')), 1),
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.helper.trans(`dispute_result.${_ctx.deal.disputeResult}`)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.helper.trans(_ctx.deal.merchantMakerSum ? 'labels.trader_rate_merchant_rate' : 'labels.rate')), 1),
          _createElementVNode("td", null, [
            _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.deal.takerSum.amount / _ctx.deal.makerSum.amount, _ctx.deal.takerSum.subunit)), 1),
            (_ctx.deal.merchantMakerSum)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" / " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.deal.takerSum.amount / _ctx.deal.merchantMakerSum.amount, _ctx.deal.takerSum.subunit)), 1)
                ], 64))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.deal.takerSum.currency), 1)
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.helper.trans('labels.in_sum')), 1),
          _createElementVNode("td", null, [
            _createElementVNode("div", null, [
              (_ctx.deal.actualTakerSum)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                    _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.actualTakerSum)) + " ", 1),
                    _createVNode(_component_copy_button, {
                      value: _ctx.deal.actualTakerSum.amount
                    }, null, 8, ["value"])
                  ]))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass({'text-decoration-line-through': _ctx.deal.isActualSumsChanged})
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.takerSum)) + " ", 1),
                    _createVNode(_component_copy_button, {
                      value: _ctx.deal.takerSum.amount
                    }, null, 8, ["value"])
                  ], 2)),
              (_ctx.deal.takerSum.currency !== _ctx.deal.makerSum.currency)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "/"))
                : _createCommentVNode("", true),
              (_ctx.deal.takerSum.currency !== _ctx.deal.makerSum.currency)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                    (_ctx.deal.actualMakerSum)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                          _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.actualMakerSum)) + " ", 1),
                          _createVNode(_component_copy_button, {
                            value: _ctx.deal.actualMakerSum.amount
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass({'text-decoration-line-through': _ctx.deal.isActualSumsChanged})
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.makerSum)) + " ", 1),
                          _createVNode(_component_copy_button, {
                            value: _ctx.deal.makerSum.amount
                          }, null, 8, ["value"])
                        ], 2))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.helper.trans('labels.out_sum')), 1),
          _createElementVNode("td", {
            class: _normalizeClass({'text-danger': _ctx.deal.type === _ctx.Direction.PAY_IN, 'text-success': _ctx.deal.type === _ctx.Direction.PAY_OUT})
          }, [
            _createElementVNode("div", null, [
              (_ctx.deal.actualMakerSum)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                    _createTextVNode(_toDisplayString(_ctx.deal.type === _ctx.Direction.PAY_IN ? '-' : '+') + _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.actualMakerSum)) + " ", 1),
                    _createVNode(_component_copy_button, {
                      value: _ctx.deal.actualMakerSum.amount
                    }, null, 8, ["value"])
                  ]))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass({'text-decoration-line-through': _ctx.deal.isActualSumsChanged})
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.deal.type === _ctx.Direction.PAY_IN ? '-' : '+') + _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.makerSum)) + " ", 1),
                    _createVNode(_component_copy_button, {
                      value: _ctx.deal.makerSum.amount
                    }, null, 8, ["value"])
                  ], 2)),
              (_ctx.deal.takerSum.currency !== _ctx.deal.makerSum.currency)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "/"))
                : _createCommentVNode("", true),
              (_ctx.deal.takerSum.currency !== _ctx.deal.makerSum.currency)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                    (_ctx.deal.actualTakerSum)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                          _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.actualTakerSum)) + " ", 1),
                          _createVNode(_component_copy_button, {
                            value: _ctx.deal.actualTakerSum.amount
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass({'text-decoration-line-through': _ctx.deal.isActualSumsChanged})
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.takerSum)) + " ", 1),
                          _createVNode(_component_copy_button, {
                            value: _ctx.deal.takerSum.amount
                          }, null, 8, ["value"])
                        ], 2))
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]),
        (_ctx.deal.rewardSum)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
              _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.helper.trans('labels.reward_sum')), 1),
              _createElementVNode("td", {
                class: _normalizeClass(parseFloat(_ctx.deal.rewardSum.amount) >= 0 ? 'text-success' : 'text-danger')
              }, [
                (_ctx.deal.actualRewardSum)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.actualRewardSum)) + " ", 1),
                      _createVNode(_component_copy_button, {
                        value: _ctx.deal.actualRewardSum.amount
                      }, null, 8, ["value"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.deal.actualRewardSum || _ctx.deal.isActualSumsChanged)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass({'text-decoration-line-through': _ctx.deal.isActualSumsChanged})
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.rewardSum)) + " ", 1),
                      _createVNode(_component_copy_button, {
                        value: _ctx.deal.rewardSum.amount
                      }, null, 8, ["value"])
                    ], 2))
                  : _createCommentVNode("", true)
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.deal.refRewardSum && _ctx.hasRole([_ctx.UserRole.ADMIN, _ctx.UserRole.TRADER_TEAM_LEAD, _ctx.UserRole.OPERATOR]))
          ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
              _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.helper.trans('labels.ref_reward_sum')), 1),
              _createElementVNode("td", _hoisted_36, [
                (_ctx.deal.actualRefRewardSum)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createTextVNode(" +" + _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.actualRefRewardSum)) + " ", 1),
                      _createVNode(_component_copy_button, {
                        value: _ctx.deal.actualRefRewardSum.amount
                      }, null, 8, ["value"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.deal.actualRefRewardSum || _ctx.deal.isActualSumsChanged)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass({'text-decoration-line-through': _ctx.deal.isActualSumsChanged})
                    }, [
                      _createTextVNode(" +" + _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.refRewardSum)) + " ", 1),
                      _createVNode(_component_copy_button, {
                        value: _ctx.deal.refRewardSum.amount
                      }, null, 8, ["value"])
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_38, _toDisplayString(_ctx.helper.trans('labels.buyer')), 1),
          _createElementVNode("td", _hoisted_39, [
            _createTextVNode(_toDisplayString(_ctx.deal.takerId ?? 'n/a') + " ", 1),
            (_ctx.deal.takerId)
              ? (_openBlock(), _createBlock(_component_copy_button, {
                  key: 0,
                  value: _ctx.deal.takerId
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_40, _toDisplayString(_ctx.helper.trans('labels.requisites')), 1),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_PayMethodIcon, {
                method: _ctx.deal.paymentMethod,
                class: "align-self-center"
              }, null, 8, ["method"]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("small", _hoisted_43, _toDisplayString(_ctx.helper.trans('payment_options.' + _ctx.deal.paymentOption)), 1),
                _createElementVNode("span", null, [
                  (_ctx.deal.paymentOption === _ctx.PaymentOption.MANUAL_ECOM || _ctx.deal.paymentOption === _ctx.PaymentOption.TO_CARD)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatCardRequisites(_ctx.deal.paymentRequisites.requisites)), 1),
                        _createVNode(_component_copy_button, {
                          value: _ctx.formatCardRequisites(_ctx.deal.paymentRequisites.requisites),
                          class: "ms-1"
                        }, null, 8, ["value"])
                      ], 64))
                    : (_ctx.deal.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR && !_ctx.helper.dealQrCodeLink(_ctx.deal))
                      ? (_openBlock(), _createElementBlock("small", _hoisted_44, _toDisplayString(_ctx.helper.trans('labels.manual_sbp_qr_awaiting_link')), 1))
                      : (!_ctx.helper.isEmvQrOption(_ctx.deal.paymentOption) && (!!_ctx.deal.paymentRequisites.requisites || (_ctx.deal.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR && _ctx.helper.dealQrCodeLink(_ctx.deal))))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (_ctx.deal.paymentOption === _ctx.PaymentOption.SBP_QR && _ctx.deal.paymentRequisites.requisites?.startsWith('http'))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: _ctx.deal.paymentRequisites.requisites,
                                  target: "_blank"
                                }, _toDisplayString(_ctx.helper.domain(_ctx.deal.paymentRequisites.requisites)), 9, _hoisted_45))
                              : (_ctx.deal.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR && _ctx.helper.dealQrCodeLink(_ctx.deal))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    href: _ctx.helper.dealQrCodeLink(_ctx.deal),
                                    target: "_blank"
                                  }, _toDisplayString(_ctx.helper.domain(_ctx.helper.dealQrCodeLink(_ctx.deal))), 9, _hoisted_46))
                                : (_ctx.deal.paymentOption === _ctx.PaymentOption.CLICK_UZ_QR && _ctx.deal.paymentRequisites.requisites?.startsWith('http'))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 2,
                                      href: _ctx.deal.paymentRequisites.requisites,
                                      target: "_blank"
                                    }, _toDisplayString(_ctx.helper.trans('labels.my_click_uz')), 9, _hoisted_47))
                                  : (_ctx.deal.paymentOption === _ctx.PaymentOption.TIPS && _ctx.deal.paymentRequisites.requisites?.startsWith('http'))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 3,
                                        href: _ctx.deal.paymentRequisites.requisites,
                                        target: "_blank"
                                      }, _toDisplayString(_ctx.helper.domain(_ctx.deal.paymentRequisites.requisites)), 9, _hoisted_48))
                                    : (_ctx.deal.paymentRequisites.requisites?.startsWith('http'))
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 4,
                                          href: _ctx.deal.paymentRequisites.requisites,
                                          target: "_blank"
                                        }, _toDisplayString(_ctx.helper.domain(_ctx.deal.paymentRequisites.requisites)), 9, _hoisted_49))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.deal.paymentRequisites.requisites), 1)),
                            _createVNode(_component_copy_button, {
                              value: _ctx.deal.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR && _ctx.helper.dealQrCodeLink(_ctx.deal) ? _ctx.helper.dealQrCodeLink(_ctx.deal) : _ctx.deal.paymentRequisites.requisites,
                              class: "ms-1"
                            }, null, 8, ["value"])
                          ], 64))
                        : _createCommentVNode("", true)
                ]),
                (_ctx.helper.isEmvQrOption(_ctx.deal.paymentOption))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_vue_qrcode, {
                          value: _ctx.helper.emvQrData(_ctx.deal),
                          tag: "svg",
                          class: "viet-qr-payment__qr",
                          style: {"width":"100%","border-radius":"10px"},
                          options: { width: '200px' }
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("small", _hoisted_52, _toDisplayString(_ctx.helper.trans('labels.raw_field.qrString')), 1),
                        _createVNode(_component_copy_button, {
                          value: _ctx.helper.emvQrData(_ctx.deal)
                        }, null, 8, ["value"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ManualSbpQrLinkEditor, {
                  "bootstrap-modal": "",
                  deal: _ctx.deal,
                  onApplied: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('manual-sbp-qr-updated', $event)))
                }, null, 8, ["deal"]),
                (_ctx.deal.paymentOption === _ctx.PaymentOption.SBP_QR && _ctx.deal.requisites && !_ctx.deal.requisites.requisites.startsWith('http'))
                  ? (_openBlock(), _createElementBlock("small", _hoisted_53, _toDisplayString(_ctx.deal.requisites.requisites), 1))
                  : (_openBlock(), _createElementBlock("small", _hoisted_54, _toDisplayString(_ctx.deal.paymentRequisites.holder), 1))
              ])
            ])
          ])
        ]),
        (_ctx.deal.paymentOption === _ctx.PaymentOption.MANUAL_ECOM && _ctx.deal.manualEcom3dsCode)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [
              _createElementVNode("th", _hoisted_56, _toDisplayString(_ctx.helper.trans('labels.manual_ecom_3ds_code')), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.deal.manualEcom3dsCode), 1)
            ]))
          : _createCommentVNode("", true),
        ((_ctx.hasRole([_ctx.UserRole.ADMIN, _ctx.UserRole.OPERATOR])) && _ctx.deal.timeSpentCreateDeal !== null && _ctx.deal.timeSpentCreateDeal !== undefined)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_57, [
              _createElementVNode("th", _hoisted_58, _toDisplayString(_ctx.helper.trans('labels.time_spent_create_deal')), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.deal.timeSpentCreateDeal.toFixed(3)) + " сек.", 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.deal.matchingPayoutDeal && _ctx.deal.type === _ctx.Direction.PAY_OUT)
      ? (_openBlock(), _createBlock(_component_MatchingPayInDealsDetailsTable, {
          key: 1,
          "deal-id": _ctx.deal.matchingPayoutDeal.dealId
        }, null, 8, ["deal-id"]))
      : _createCommentVNode("", true),
    (_ctx.deal.transferTransaction)
      ? (_openBlock(), _createBlock(_component_TransferTransactionDetailsTable, {
          key: 2,
          transaction: _ctx.deal.transferTransaction
        }, null, 8, ["transaction"]))
      : _createCommentVNode("", true),
    (_ctx.deal.externalNspkTransaction)
      ? (_openBlock(), _createBlock(_component_ExternalNSPKTransactionDetailsTable, {
          key: 3,
          transaction: _ctx.deal.externalNspkTransaction
        }, null, 8, ["transaction"]))
      : _createCommentVNode("", true),
    (_ctx.hasRole([_ctx.UserRole.ADMIN, _ctx.UserRole.OPERATOR, _ctx.UserRole.TRADER, _ctx.UserRole.TRADER_OPERATOR]) && _ctx.dealHistoriesResponse.items.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
          _createElementVNode("table", _hoisted_60, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_61, [
                  _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.helper.trans('labels.history')), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_63, _toDisplayString(_ctx.helper.trans('labels.date')), 1),
                _createElementVNode("th", _hoisted_64, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
                (!(_ctx.isTrader || _ctx.isTraderOperator))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_65, _toDisplayString(_ctx.helper.trans('labels.trader')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("th", _hoisted_66, _toDisplayString(_ctx.helper.trans('labels.initiator')), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dealHistoriesResponse.items, (history) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: history.id
                }, [
                  _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.dateHelper.format(history.date)), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", null, [
                        (history.action)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(_ctx.helper.trans(`deal_history_action.${history.action}`)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(_ctx.helper.trans(`deal_status.${history.status}`)), 1)),
                        (!history.action && history.disputeAttachment)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 2,
                              href: `${_ctx.api.baseUrl()}/attachments/${history.disputeAttachment}`,
                              target: "_blank",
                              type: "button",
                              class: "me-2 text-warning"
                            }, _cache[12] || (_cache[12] = [
                              _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)
                            ]), 8, _hoisted_71))
                          : _createCommentVNode("", true)
                      ]),
                      (history.action === 'AMOUNT_CHANGED' && history.previousAmount && history.newAmount)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_72, _toDisplayString(history.previousAmount) + " -> " + _toDisplayString(history.newAmount) + " " + _toDisplayString(history.amountCurrency || ''), 1))
                        : _createCommentVNode("", true),
                      (history.action === 'DISPUTE_AUTOCLOSE_PAUSED' && history.suspendDisputeAutocloseAt)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_73, _toDisplayString(_ctx.helper.trans('labels.pause_until', {date: _ctx.dateHelper.format(history.suspendDisputeAutocloseAt), comment: history.suspendDisputeComment || ''})), 1))
                        : _createCommentVNode("", true),
                      (!history.action && (history.disputeReason === _ctx.DisputeReason.INVALID_SUM || history.disputeReason === _ctx.DisputeReason.PART_PAYOUT))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_74, [
                            _cache[13] || (_cache[13] = _createTextVNode(" (")),
                            _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.helper.trans(`dispute_reason.${history.disputeReason}`)), 1),
                            _createTextVNode(": " + _toDisplayString(_ctx.numberFormatter.formatNumber(history.disputeReasonData.amount, 2)) + " " + _toDisplayString(_ctx.deal.takerSum.currency) + ") ", 1)
                          ]))
                        : (!history.action && _ctx.isPayOutReceiptCheck(_ctx.deal.type, history.disputeReason))
                          ? (_openBlock(), _createBlock(_component_ReceiptCheckStatus, {
                              key: 3,
                              reason: history.disputeReason,
                              data: history.disputeReasonData
                            }, null, 8, ["reason", "data"]))
                          : (!history.action && history.disputeReason)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_76, " (" + _toDisplayString(_ctx.helper.trans(`dispute_reason.${history.disputeReason}`)) + ") ", 1))
                            : _createCommentVNode("", true)
                    ])
                  ]),
                  (!(_ctx.isTrader || _ctx.isTraderOperator))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_77, [
                        (history.trader)
                          ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                              key: 0,
                              user: history.trader
                            }, null, 8, ["user"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_78, "n/a"))
                      ]))
                    : _createCommentVNode("", true),
                  ((_ctx.isTrader || _ctx.isTraderOperator))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_79, [
                        (history.initiatorRole)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_80, _toDisplayString(_ctx.helper.trans(`user_roles.${history.initiatorRole}`)), 1))
                          : (_openBlock(), _createElementBlock("small", _hoisted_81, _toDisplayString(_ctx.helper.trans(`initiator_type.${history.initiatorType}`)), 1))
                      ]))
                    : _createCommentVNode("", true),
                  (!(_ctx.isTrader || _ctx.isTraderOperator))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("small", null, _toDisplayString(_ctx.helper.trans(`initiator_type.${history.initiatorType}`)), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!(_ctx.isTrader || _ctx.isTraderOperator))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          (history.initiator)
                            ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                key: 0,
                                "show-badge": "",
                                user: history.initiator
                              }, null, 8, ["user"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          (_ctx.dealHistoriesResponse.totalCount > _ctx.dealHistoriesResponse.items.length)
            ? (_openBlock(), _createBlock(_component_b_pagination, {
                key: 0,
                modelValue: _ctx.historyPage,
                "onUpdate:modelValue": [
                  _cache[7] || (_cache[7] = ($event: any) => ((_ctx.historyPage) = $event)),
                  _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadHistory()))
                ],
                "total-rows": _ctx.dealHistoriesResponse.totalCount,
                "per-page": _ctx.dealHistoriesResponse.limit,
                limit: 20,
                "prev-text": "Back",
                "next-text": "Next",
                align: "start",
                "first-number": "",
                "hide-goto-end-buttons": "",
                "hide-ellipsis": ""
              }, null, 8, ["modelValue", "total-rows", "per-page"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_b_modal, {
      title: _ctx.helper.trans('labels.client_card'),
      modelValue: _ctx.clientCardData !== null,
      "footer-class": "d-flex justify-content-end",
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.clientCardData = null))
    }, _createSlots({
      footer: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-dark btn-sm text-capitalize-first",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clientCardData = null))
        }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
      ]),
      _: 2
    }, [
      (_ctx.clientCardData)
        ? {
            name: "default",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.helper.trans('labels.card_number')), 1),
                  _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.clientCardData.cardNumber), 1)
                ]),
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.helper.trans('labels.expiry')), 1),
                  _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.clientCardData.expiryMonth) + "/" + _toDisplayString(_ctx.clientCardData.expiryYear), 1)
                ]),
                _createElementVNode("div", _hoisted_93, [
                  _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.helper.trans('labels.cardholder')), 1),
                  _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.clientCardData.cardholderName), 1)
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.helper.trans('labels.cvv')), 1),
                  _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.clientCardData.cvv), 1)
                ])
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["title", "modelValue"]),
    _createVNode(_component_InvoiceRequestsTimelineModal, { ref: "invoiceRequestsTimelineModal" }, null, 512),
    _createVNode(_component_WebhookHistoryModal, { ref: "webhookHistoryModal" }, null, 512),
    _createVNode(_component_MerchantRequestLogModal, { ref: "merchantRequestLogModal" }, null, 512)
  ]))
}